import styled from 'styled-components/macro';
import { MD, SM } from '@zendeskgarden/react-typography';
import { variables } from 'theme/variables';
import { Col } from '@zendeskgarden/react-grid';

const { custom_silver: customSilver, custom_blue: customBlue } = variables;

export const HeaderMd = styled(MD)`
  height: 40px;
  font-size: 16px;
  margin-bottom: 0;
`;

export const SubMd = styled(MD)`
  font-size: 12px !important;
  font-weight: 400;
  line-height: 15px;
  margin-top: -3px;
`;

export const NomLabel = styled(MD)`
  font-size: 12px !important;
  font-weight: 400;
  line-height: 15px;
  margin-right: 35px;
  width: 180px;
`;

export const ListingSizeAndStrength = styled('div')`
  ${(props) =>
    props.isDashboard && !props.isPreview ? 'overflow: auto' : null};
  ${(props) =>
    props.newListings
      ? `
  padding: 40px 25px 40px 50px;
  background-image: ${
    props.isDashboard ? 'none' : 'url("/images/sizeAndStrengthImage.svg")'
  };
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 40% 90%;
  .sizeCol {
    min-width: 300px;
    max-width: 350px;
    margin-bottom: 20px;
  }
  .strengthCol {
    max-width: 300px;
    min-width: 290px;
  }
  .secondDivider {
    padding-top: 10px;
    margin-bottom: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid ${customSilver}
    justify-content: space-between;
  }
  .firstStrengthNum {
    padding-top: 10px;
    justify-content: space-between;
  }
  .lastNomNum {
    padding-top: 10px;
  }
  .strengthRow {
    justify-content: space-between;
  }
  @media (max-width: 1150px) {
    padding-left: 25px;
    .strengthCol {
      margin-bottom: 30px;
    }
  }
  @media (max-width: 769px) {
    background-image: none;
    padding-left: 0;
    .strengthNum {
      font-size: 0.9rem;
    }
    .nomNum {
      font-size: 0.9rem;
    }
    .strengthCol {
      max-width: 330px;
    }
  }
  @media (max-width: 745px) {
    .sizeCol {
      min-width: 0;
    }
    .strengthCol {
      min-width: 0;
    }
  }
  @media (max-width: 600px) {
    ${!props.isPreview && `padding-bottom: 30px;`}
    .nomRow {
      flex: display;
      justify-content: space-between;
    }
    .strengthCol {
      max-width: 330px;
    }
    .strengthRow {
      flex: display;
      justify-content: space-between;
    }
    .divider {
      display: none;
    }
    .secondDivider {
      border-bottom: none;
      margin-bottom: 0;
      paddiing-bottom: 0;
    }
    .dataRow {
     display: flex;
     flex-wrap: wrap;
     flex-direction: column;
    }
    .strengthCol {
      max-width: 350px;
      ${
        !props.isPreview
          ? `
      margin-bottom: 0;
      `
          : null
      }
    }
    .firstStrengthNum {
      padding-top: 5px;
    }
    .lastNomNum {
      padding-bottom: 10px;
    }
  }
  @media(max-width: 472px) {
    overflow-x: scroll;
  }
  @media (max-width: 425px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  `
      : ``}
`;

export const DisclaimerCol = styled(Col)`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

export const Disclaimer = styled(SM)`
  font-size: 12px;
  line-height: 20px;
  margin-top: 30px;
  max-width: 1100px;
  padding-bottom: 20px;
  padding-left: ${(props) => (props.notProd ? '20px' : '0')};
  ${(props) =>
    props.notProd
      ? `
    position: absolute;
    bottom: -100px;
  `
      : ``}
  #contactUs {
    border: none;
    padding: 0;
    color: ${customBlue};
    min-width: 0;
    padding-bottom: 1px;
    virtical-align: baseline;
    &:hover {
      background-color: white;
    }
  }
  @media (max-width: 895px) {
    ${(props) =>
      props.isPreview
        ? `
    max-height: 200px;
    overflow-x: auto;
    `
        : null}
  }
  @media (max-width: 699px) {
    ${(props) =>
      props.notProd
        ? `
      padding-left: 0;
      bottom: -150px;
    `
        : ``}
  }
  @media (max-width: 600px) {
    max-height: 220px;
    overflow-x: auto;
    margin-top: 0;
  }
  @media (max-width: 565px) {
    padding-top: 30px;
    ${(props) =>
      props.notProd
        ? `
      bottom: -160px;
    `
        : ``}
  }
  @media (max-width: 425px) {
    margin-left: -60px;
    ${(props) =>
      !props.isPreview
        ? `
    max-width: 270px;
    `
        : `
    max-width: 320px;
    `}
  }
`;
